export default "__VITE_ASSET__d8ysPDZ2__"